import cx from 'classnames';

interface IContent {
    className?: string;
    children: React.ReactNode;
}

const Content = ({ className = '', children }: IContent) => {
    return (
        <p className={cx('text-lg sm:text-xl', {
            [className]: Boolean(className)
        })}>
            {children}
        </p>
    );
};

export { Content };